import { type Booking, type BookingClient, type ReminderSettings } from '../../../models/Scheduling'
import { type TemplateValue } from '../../../models/TemplateLibrary'
import { type ReminderTemplateChoices } from '../../../store/ai/inputParametersHierarchy'

export const needsFixing = (template: TemplateValue): boolean => typeof template.template.subject !== 'string' || typeof template.template.body !== 'string'

export const zocksDefault = (templates: TemplateValue[]): TemplateValue | undefined => templates.find((template) => template.scope === 'system')

export const chosenTemplate = (templates: TemplateValue[], templateId: string | undefined): TemplateValue | undefined => {
  const template = templateId != null ? templates.find((candidate) => candidate.id === templateId) : undefined
  return template != null && !needsFixing(template) ? template : zocksDefault(templates)
}

export const preselectedTemplate = (
  templates: TemplateValue[],
  followUp: ReminderSettings | undefined,
  choices: ReminderTemplateChoices,
): TemplateValue | undefined => {
  if (followUp == null || !followUp.enabled) {
    return zocksDefault(templates)
  }
  const templateIds = new Set(followUp.entries.map((entry) => (entry.id != null ? choices[entry.id]?.templateId : undefined)))
  if (templateIds.size !== 1) {
    return zocksDefault(templates)
  }
  const [templateId] = templateIds
  return chosenTemplate(templates, templateId)
}

export const reminderRecipients = (booking: Booking): BookingClient[] => booking.clients.filter((client) => client.email && !client.unsubscribedAt)
